module.exports = __webpack_public_path__ + "logo.95d4364f1543174f6017.png";


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/ITN/srvHCWaba/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles